// l'idee est de créer des points de sauvegarde a la main, et de reprendre à cet endroit

import SequencesManager from "react-sdk/haxelibs/SequencesManager"
import AppState from "./AppState"

import Catalogue from "./Catalogue/Catalogue"
import Ftues from "./Ftues"

class SaveGame {
  
  saveKey = "bizness-lot3"

  hasSave() {
    let save = null
    if (AppState.scorm.api)
      save = AppState.scorm.get_savegame();
    else {
      save = localStorage.getItem(this.saveKey)
    }

      return (save != null);
  }


  save() {
    let state = {
      sm_state: SequencesManager.stateToJson(),
      ftue: Ftues.stateToJson(),
      moduleStars: AppState.moduleStars,
      uiState: AppState.UI_visibilities,
      catalog: Catalogue.stateToJson(),
    }

    if (AppState.scorm.api)
      AppState.scorm.set_savegame(state, 0);
    else
      localStorage.setItem(this.saveKey, JSON.stringify(state))
    
  }

  load() {
    if (this.hasSave()) {
      let save = null
      if (AppState.scorm.api)
        save = AppState.scorm.get_savegame();
      else {
      save = localStorage.getItem(this.saveKey)
    }
      
      if(save) {
        let data = JSON.parse(save)

        SequencesManager.stateFromJson(data.sm_state)
        AppState.moduleStars = data.moduleStars
        Ftues.stateFromJson(data.ftue)

        AppState.UI_visibilities = data.uiState
        Catalogue.stateFromJson(data.catalog)
      }
    }
  }

  clearSave() {
    if (this.hasSave()) {
      
      if (AppState.scorm.api)
        AppState.scorm.set_savegame(null, 0);
      else
        localStorage.removeItem(this.saveKey)
    }
  }
}


export default new SaveGame()